<script setup lang="ts">
import { type CheckpointModel } from '@/types/models/CheckpointModel'
import { EditableStringField, InformationBaseCard, StackLayout } from '@rfc/rfc-components-library'
import { computed } from 'vue'

type Props = {
    eventId: number
    data: Partial<CheckpointModel>
    isSubmitted: boolean
    editMode?: boolean
}
const props = defineProps<Props>()
const emit = defineEmits<{
    (e: 'change', value: Partial<CheckpointModel>): void
}>()

const checkpointData = computed({
    get: () => props.data,
    set: value => emit('change', value)
})

const errors = computed(() => ({
    checkpointNameError: props.isSubmitted && !checkpointData.value.name
}))
</script>

<template>
    <InformationBaseCard :label="$t('event.detail.informations.informationsTitle')" class="w-full">
        <StackLayout direction="column" :gap="8" class="w-full">
            <EditableStringField
                :label="$t('checkpoint.model.name')"
                :modelValue="checkpointData.name"
                :editMode="editMode"
                :placeholder="$t('checkpoint.model.name')"
                boldLabel
                :hasError="errors.checkpointNameError"
                required
                @change="value => (checkpointData.name = value)" />
            <EditableStringField
                :label="$t('checkpoint.model.comments')"
                :modelValue="checkpointData.comments"
                :editMode="editMode"
                :placeholder="$t('checkpoint.model.comments')"
                boldLabel
                @change="value => (checkpointData.comments = value)" />
        </StackLayout>
    </InformationBaseCard>
</template>
